import React from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import ReactLoading from 'react-loading';

export default function MyTimeline(props) {
  const { dotContents } = props;

  return (
    <div style={{ position: 'absolute', width: '100%' }}>
      <Timeline align='left'>
        {dotContents.length === 0 || typeof dotContents === 'string' ? (
          <ReactLoading
            delay={3000}
            type={'balls'}
            height={'20%'}
            width={'20%'}
          />
        ) : (
          dotContents.map((dotContent, index) => (
            <TimelineItem key={index}>
              <TimelineSeparator>
                <TimelineDot color='secondary' />
                {index !== dotContents.length - 1 && <TimelineConnector />}
              </TimelineSeparator>
              <TimelineContent style={{ color: 'white' }}>
                {dotContent}
              </TimelineContent>
            </TimelineItem>
          ))
        )}
      </Timeline>
    </div>
  );
}
